import { render } from "./index.vue?vue&type=template&id=bc60fe42&ts=true"
import script from "./index.vue?vue&type=script&scoped=true&lang=ts"
export * from "./index.vue?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__